export default "__VITE_ASSET__B3EyEtXb__"